import {RegionSelectPageActionsType} from 'app/components/region/types/RegionSelectPageActionTypes';
import RegionSelectPageState from 'app/components/region/types/RegionSelectPageState';

const RegionSelectPageReducer = (
  state: RegionSelectPageState,
  action: RegionSelectPageActionsType
): RegionSelectPageState => {
  switch (action.type) {
    case 'REGIONS_FETCHING':
      return {...state, regions: {...state.regions, isFetching: true}};
    case 'REGIONS_UPDATE':
      return {...state, regions: {isFetching: false, items: action.data}};
    case 'DISTRICTS_FETCHING':
      return {
        ...state,
        districts: {
          ...state.districts,
          [action.data.key]: {isFetching: true, items: []},
        },
      };
    case 'DISTRICTS_UPDATE':
      return {
        ...state,
        districts: {
          ...state.districts,
          [action.data.key]: {
            isFetching: false,
            items: action.data.items,
          },
        },
      };
    default:
      return state;
  }
};

export {RegionSelectPageReducer};
